import * as React from 'react'

import cn from 'classnames/bind'

import Separator from 'modules/core/components/Separator'

import styles from './index.module.scss'

type Types = 'brand' | 'primary' | 'negative'
interface Props {
  compact?: boolean
  color?: string
  subtitle?: string
  label?: React.ReactNode
  type?: Types
  separator?: boolean
  centered?: boolean
}

const cx = cn.bind(styles)

const Title = ({ compact, color, centered, label, subtitle, separator, type }: Props) => {
  return (
    <div
      className={cx('root', {
        centered,
        compact,
      })}
    >
      {!!subtitle && <h3 className={cx('subtitle', type)}>{subtitle}</h3>}
      <h2 className={cx('title', type)}>{label}</h2>
      {separator && (
        <div className={styles.separator}>
          <Separator color={color} type={type || 'brand'} />
        </div>
      )}
    </div>
  )
}

export default Title
